var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "password_icon",
    "data-name": "password icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 22.313,
    viewBox: "0 0 17 22.313",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "password_icon-2",
    "data-name": "password icon",
    d: "M9.594,24.313A1.587,1.587,0,0,1,8,22.719V11.191A1.587,1.587,0,0,1,9.594,9.6h1.859V7.047a4.865,4.865,0,0,1,1.474-3.573A4.865,4.865,0,0,1,16.5,2a4.865,4.865,0,0,1,3.573,1.474,4.865,4.865,0,0,1,1.474,3.573V9.6h1.859A1.587,1.587,0,0,1,25,11.191V22.719a1.587,1.587,0,0,1-1.594,1.594Zm0-1.594H23.406V11.191H9.594ZM16.5,19a1.994,1.994,0,0,0,1.448-.584,1.9,1.9,0,0,0,.6-1.408,2.091,2.091,0,0,0-.6-1.448,1.936,1.936,0,0,0-2.9,0,2.091,2.091,0,0,0-.6,1.448,1.9,1.9,0,0,0,.6,1.408A1.994,1.994,0,0,0,16.5,19ZM13.047,9.6h6.906V7.047A3.446,3.446,0,0,0,16.5,3.594a3.446,3.446,0,0,0-3.453,3.453ZM9.594,22.719v0Z",
    transform: "translate(-8 -2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password_icon.5a0e37642cffcff6f6c0b19df98c8036.svg";
export { ForwardRef as ReactComponent };